import AMegMen from 'amegmen';

var  amegmen_instance = AMegMen.Root.getInstance();
var  amegmen_options = {
};
amegmen_instance.init(".__amegmen", amegmen_options);